module.exports = __webpack_public_path__ + "img/logo-smart-orange-outline.38b504ff.png";